import { render } from "./FleetSection.vue?vue&type=template&id=2ddbedd3"
import script from "./FleetSection.vue?vue&type=script&lang=js"
export * from "./FleetSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__